//메인화면 헤더
import React, { useEffect, useState, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";

//MUI
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  ButtonBase,
  Divider,
  IconButton,
  Stack,
  Typography,
  Chip,
  Tooltip,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { makeStyles } from "@material-ui/core/styles";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CircleIcon from "@mui/icons-material/Circle";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";

import MenuList from "./MenuList";
import { fni18n } from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService.js";

import logo from "../../assets/images/logo/ezcams_black.png";

import { useAtom } from "jotai";
import menuAtom from "../../utils/reducer/menuAtom";
import { DASH_INFO } from "../../config";

const MainHeader = ({ handleLeftDrawerToggle }) => {
  const isUserName = AuthenticationService.getLoggedInUserName(); // 유저Name GET
  const groupName = AuthenticationService.getLoggedInUserGroup();
  const branchName = AuthenticationService.getLoggedInUserBranch();
  const storeName = AuthenticationService.getLoggedInUserStore();
  const isUserId = AuthenticationService.getLoggedInUserID(); // 유저ID GET
  const userName = isUserName ? isUserId + "(" + isUserName + ")" : isUserId;

  const theme = useTheme();
  const useStyles = makeStyles({
    logo: {
      maxWidth: 110,
      marginRight: "15px",
    },
    chips: {
      fontSize: 16,
      height: 44,
      backgroundColor: theme.custom.appbarBgColor,
      border: "1px solid #DDDDDD",
      borderRadius: "10px",
      "& .MuiChip-label": {
        color: theme.link.logo,
      },
      "& .MuiChip-icon": {
        color: "#8D7C57",
      },
    },
  });
  const classes = useStyles();
  const history = useHistory();
  const [menu, setMenu] = useAtom(menuAtom);

  // const [isUserName, setIsUserName] = useState("");

  const isUserLoggedIn = AuthenticationService.isUserLoggedIn(); // 로그인 체크 (true, false)
  // const isUserId = AuthenticationService.getLoggedInUserID();  // 유저ID GET

  /*
    useEffect(() => {
        const ApiConnect = () => {
            try {
                if (isUserId) {
                    GetLoggedInUserName(isUserId)
                    .then((res) => setIsUserName(res.data.USER_NM))
                    .catch((err) => {
                        AuthenticationService.logout();
                        window.location.href = "/logout";
                    });
                }
            } catch (e) {
                AuthenticationService.logout();
                window.location.href = "/logout";
            }
        };
        ApiConnect();
      }, [isUserId, isUserLoggedIn]);
    */
  /*const stringAvatar = useMemo(() => {
    const userName = isUserName.trim().toUpperCase();
    if (userName) {
      if (userName.includes(" ")) {
        return userName.split(" ")[0][0] + userName.split(" ")[1][0];
      }
      if (userName.length > 2) {
        return userName.substring(userName.length - 2, userName.length);
      }
      return userName;
    }
  }, [isUserName]);*/

  const logout = () => {
    AuthenticationService.logout();
    // history.push(`/logout`);
    history.push(`/login`);
  };
  const clickLogo = () => {
    setMenu((item) => ({
      ...item,
      selected: DASH_INFO.P_PAGE_NO,
      marked: DASH_INFO.PAGE_NO,
      opened: true,
    }));
    history.push(DASH_INFO.PAGE_URL);
  };
  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: "flex",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <Box
          component="span"
          sx={{
            display: { xs: "none", md: "block" },
            flexGrow: 1,
            //  backgroundColor: theme.custom.drawerBgColor,
            //  ml: "-24px",
            //  width: "224px",
          }}
        >
          {/* <LogoSection /> */}
          <IconButton style={theme.link.logo} onClick={clickLogo}>
            {/* <Typography variant="h4" align="center" >ezCAMS</Typography> */}
            <img src={logo} alt="" className={classes.logo} />
          </IconButton>
        </Box>
      </Box>

      {/* header Menu */}
      <MenuList />

      {/* 사용자 정보 / 로그아웃 버튼 */}
      <Box
        sx={{
          position: "absolute",
          right: "0",
          width: "500px",
          height: "auto",
        }}
      >
        <Stack direction="row" justifyContent="flex-end" alignItems="center">
          <Tooltip
            title={
              <>
                <Typography variant="subtitle2" align="left">
                  ezCAMS {fni18n("계정")}<br/>
                  {/* {fni18n("아이디")} */}
                  {isUserId}<br/>
                  {/* {fni18n("역할")} */}
                  {groupName}<br/>
                  {/* {fni18n("소속")} */}
                  {storeName + " " + branchName}<br/>
                </Typography>
              </>
            }
          >
            <Chip
              className={classes.chips}
              label={isUserName}
              icon={<PermIdentityIcon />}
            />
          </Tooltip>
          <Chip
            sx={{ marginLeft: "10px", marginRight: "20px" }}
            className={classes.chips}
            label={fni18n("로그아웃")}
            icon={<LogoutIcon sx={{ color: "#8D7C57" }} />}
            onClick={logout}
          />
        </Stack>
      </Box>
    </>
  );
};

export default MainHeader;
